
<template>
  <div id="app">
    <div class="header">
      <div>
        会员注册
        <img src=".././assets/img/箭头 (2).png"  @click="changePage"/>
        <router-link to="/" class="login1">登陆</router-link>

        <!-- <router-link to="/login" class="login">验证码登陆</router-link> -->
      </div>
    </div>
    <div class="container">
      <div class="form">
        <img src=".././assets/img/图标.png" class="logo" />
        <input type="text" placeholder="请输入手机号" v-model="mobile" />
        <span></span>
        <input type="text" placeholder="请输入密码" v-model="usrPwd" />
        <span></span>
        <input type="text" placeholder="请输入验证码" v-model="validateCode" />
        <span v-show="show" class="code" @click="getCode">获取验证码</span>
        <span v-show="!show" class="code">{{count}} s</span>
        <span class="line"></span>
      </div>
      <div></div>
      <img src=".././assets/img/按钮(1).png" class="btn" @click="register" />
      <input type="checkbox" class="ckeck" value="同意" v-model="vals"/>
      <span class="agree">
        同意
        <i class="user">用户协议</i>
      </span>
    </div>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  data() {
    return {
      mobile: "", //手机号
      usrPwd: "", //密码
      validateCode: "", //验证码
      show: true, //是否显示获取验证码
      count: "", //倒计时数字
      timer: null, //计时器
      checked:false, //是否勾选同意协议
      vals:'' //被选中的数据
    };
  },
  mounted() {},
  methods: {
    // 获取验证码
    getCode() {
      //手机号验证
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.mobile == "") {
        this.$toast({message:'请输入手机号码',duration:'3000'})
      } else if (!reg.test(this.mobile)) {
        this.$toast({message:'手机格式不正确',duration:'3000'})
      } else {
        this.$axios.get("webcall/sms/send/validateCode", {params: { mobile: this.mobile, smsType: "SMS_REGISTER_ACCOUNT" }
        }).then(res => {
          if(res.status===200){
            if (res.data.code === "0000") {
              this.$toast({message:'验证码发送成功',duration:'3000'})
              //验证码发送成功  进入倒计时
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.show = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000);
              }
            }else{
            this.$toast(res.data.errMsg)
            }
          }else{
            this.$toast(res.data.errMsg)
          }
        });
      }
    },
    // 注册用户
    register() {
      let params={
        mobile: this.mobile,
        validateCode: this.validateCode,
        usrPwd: this.usrPwd
      }
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.mobile == "") {
        this.$toast({message:'请输入手机号码',duration:'3000'})
      } else if (!reg.test(this.mobile)) {
        this.$toast({message:'手机格式不正确',duration:'3000'})
      } else if(this.usrPwd==""){
        this.$toast({message:'请输入密码',duration:'3000'})        
      }else if(this.validateCode ==""){
        this.$toast({message:'请输入验证码',duration:'3000'})
      } else if(this.vals == ''){
        this.$toast({message:'请同意用户协议',duration:'3000'})
      }else{
      this.$axios.post("webcall/member/register",qs.stringify(params)
          ,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(res => {
          if(res.status==200){
            this.$toast(res.data.errMsg)
            if(res.data.code=='0000'){
              this.$toast({message:'注册成功',duration:'3000'})
              this.$router.push('/')
            }
          }else{
            this.$toast({message:'注册失败',duration:'3000'})
          }
        });
      }
    },
    //返回按钮
    changePage() {
      this.$router.push("/user");
    }
  }
};
</script>

<style lang="less" scoped>
#app {
  width: 750px;
  height: 1334px;
  background-color: #ffffff;
  .header {
    height: 130px;
    padding-top: 40px;
    font-size: 30px;
    color: #ffffff;
    background-color: rgba(255, 84, 79, 1);
    box-sizing: border-box;
    div {
      text-align: center;
      line-height: 90px;
      position: relative;
      .login {
        color: #ffffff;
        position: absolute;
        right: 30px;
      }
      .login1 {
        color: #ffffff;
        position: absolute;
        right: 30px;
      }
      img {
        position: absolute;
        left: 30px;
        bottom: 20px;
        width: 18px;
        height: 33px;
      }
    }
  }
  .container {
    padding: 0 62px 0 68px;
    .form {
      position: relative;

      .logo {
        margin: 82px 244px 63px 217px;
        width: 160px;
        height: 160px;
      }
      input {
        margin-top: 60px;
        border: none;
        font-size: 30px;
      }
      line {
        display: block;
        border-bottom: 2px solid #dddddd;
      }
      .code {
        position: absolute;
        bottom: 15px;
        right: 0px;
        width: 174px;
        height: 63px;
        line-height: 63px;
        text-align: center;
        font-size: 25px;
        border: 1px solid #ccc;
        border-radius: 28px;
      }
    }
    .btn {
      margin-top: 90px;
      width: 620px;
      height: 90px;
    }
  }
  .ckeck {
    width: 30px;
    height: 30px;
    margin-top: 30px;
    margin-right: 17px;
  }
  .agree {
    font-size: 30px;
    i {
      font-style: normal;
    }
  }

  .user {
    color: #ff544f;
  }
}
</style>
